import { render, staticRenderFns } from "./submit-answer-sheet.vue?vue&type=template&id=6cfd283f&scoped=true"
import script from "./submit-answer-sheet.vue?vue&type=script&lang=js"
export * from "./submit-answer-sheet.vue?vue&type=script&lang=js"
import style0 from "./submit-answer-sheet.vue?vue&type=style&index=0&id=6cfd283f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd283f",
  null
  
)

export default component.exports